/** Pages that must not probe a pre-existing vendor session on mount.
 * The SSO consumers replace that session with new cookies; a concurrent
 * refresh can rotate an old cookie across the handoff. */
const PUBLIC_AUTH_LEAVES = [
  '/login',
  '/register',
  '/forgot-password',
  '/reset-password',
  '/verify-email',
  '/auth/demo-sso',
  '/auth/admin-sso',
];

export function isPublicAuthPath(pathname: string): boolean {
  return PUBLIC_AUTH_LEAVES.some((leaf) => pathname.endsWith(leaf));
}

/** A failed SSO token exchange must show its own error, not try a stale
 * refresh cookie or redirect via the generic 401 interceptor. */
export function isSsoRedemptionRequest(pathname: string): boolean {
  return pathname.endsWith('/vendor/auth/demo-sso') || pathname.endsWith('/vendor/auth/admin-sso');
}
